import { render, staticRenderFns } from "./board-index-edit.vue?vue&type=template&id=367307c3&"
import script from "./board-index-edit.vue?vue&type=script&lang=js&"
export * from "./board-index-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports